<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      d="M13.58 9.617c2.804-1.46 5.468-2.073 7.2-2.18l.208 3.368c-1.377.085-3.66.618-6.082 1.926 1.88 1.696 3.624 3.88 4.972 6.667l-1.519.735-1.518.735c-1.295-2.675-3.022-4.688-4.844-6.184-1.822 1.496-3.547 3.51-4.842 6.184l-1.518-.735-1.52-.735c1.349-2.786 3.093-4.971 4.972-6.667-2.421-1.308-4.704-1.84-6.081-1.926l.209-3.369c1.687.105 4.262.689 6.988 2.07V3h3.375v6.617Z"
    />
  </svg>
</template>
